import Handler from './Handler';
import * as Formats from '../MediaFormats';
import { update } from 'Emitter';
import { getInstance } from 'StateManager';
import { getMimeType, getFileExtension } from 'Misc/media';
import MediaMeasurer from 'Measurement/MediaMeasurer';

export default class FileHandler extends Handler {
  constructor(options) {
    super(options);
    this.lastTime = 0;
    getInstance().registerListener(new MediaMeasurer());
    this.onEnded = this.onEnded.bind(this);
  }

  configure(videoEl, container) {
    const supported = FileHandler.playbackSupported(videoEl, this.src, this.mime);

    if(supported) {
      this.videoEl = videoEl;
      this.videoEl.setAttribute('playsinline', true);
      this.videoEl.src = this.src;
      this.addListeners(this.videoEl);
      this.ready = true;
      return Promise.resolve(this);
    } else {
      return Promise.reject(this);
    }
  }

  addListeners(el) {
    el.addEventListener('started',        this.onStarted);
    el.addEventListener('ended',          this.onEnded);
    el.addEventListener('seeked',         this.onSeeked);
    el.addEventListener('loadedmetadata', this.onDurationChange);
  }

  play() {
    this.videoEl.play();
  }

  pause() {
    this.videoEl.pause();
  }

  setVolume(volume) {
    this.videoEl.volume = volume;
  }

  onTimeUpdate(event) {
    if(this.lastTime === 0 && event.target.currentTime > 0) {
      this.onStarted(event);
    }

    this.lastTime = event.target.currentTime;
  }

  nextTick() {
    if(this.videoEl) {
      this.onTimeUpdate({ target: this.videoEl });
    }
  }

  onEnded(event) {
    if(this.videoEl) {
      this.videoEl.removeEventListener('started',        this.onStarted);
      this.videoEl.removeEventListener('ended',          this.onEnded);
      this.videoEl.removeEventListener('seeked',         this.onSeeked);
      this.videoEl.removeEventListener('loadedmetadata', this.onDurationChange);
    }
  }

  onSeeked(event) {}
  onStarted(event) {}
  onDurationChange(event) {}

  static playbackSupported(el, src, mime) {
    if(!mime) {
      const ext  = getFileExtension(src);
      mime = getMimeType(ext);
    }

    return mime && el.canPlayType && el.canPlayType(mime);
  }
}


// WEBPACK FOOTER //
// ./src/Media/Handlers/FileHandler.js